export default {
  expandChat: {evid: 523},
  sendMessage: {evid: 524},
  technicalError: {evid: 525},
  firebaseConnectionOn: {evid: 528},
  firebaseConnectionOff: {evid: 529},
  realtimeActivity: {evid: 530},
  emojiClick: {evid: 548},
  attachmentClick: {evid: 563},
  chatDisplayed: {evid: 701}
};



// WEBPACK FOOTER //
// ./chat-app/biLogger/events.js